<table role="grid"
       class="td-wb-year-picker__table"
       [hidden]="datePicker.mode !== 'year'"
       [attr.aria-labelledby]="datePicker.uniqueId + '-year-title'"
       [attr.aria-activedescendant]="datePicker.activeDateId | async">
  <thead>
  <tr>
    <th class="td-wb-table__cell--right">
      <button tdWbDatePickerButton
              [tdWbFocusOnDisabled]="yearButtonRef"
              class="td-wb-year-picker__arrow-button"
              type="button"
              (click)="datePicker.move(-1)"
              [disabled]="navPrevDisabled"
              [attr.aria-label]="'tdWb.yearPicker.PREVIOUS_YEARS' | tdWbTranslate">
        <td-wb-icon class="td-wb-day-picker__icon"
                    iconId="arrow-left"
                    size="9x14" />
      </button>
    </th>
    <th colspan="3">
      <strong class="td-wb-vh"
              [id]="datePicker.uniqueId + '-year-title'"
              aria-live="assertive"
              role="heading"
              aria-level="1"
              [innerText]="title">
      </strong>
      <button tdWbDatePickerButton
              #yearButton
              aria-live="assertive"
              aria-atomic="true"
              type="button"
              class="td-wb-full-width"
              [disabled]="true">
              <span class="td-wb-date-picker-header"
                    [innerText]="title"></span>
      </button>
    </th>
    <th class="td-wb-table__cell--left">
      <button type="button"
              class="td-wb-year-picker__arrow-button"
              tdWbDatePickerButton
              [tdWbFocusOnDisabled]="yearButtonRef"
              (click)="datePicker.move(1)"
              [disabled]="navNextDisabled"
              [attr.aria-label]="'tdWb.yearPicker.NEXT_YEARS' | tdWbTranslate">
        <td-wb-icon class="td-wb-day-picker__icon"
                    iconId="arrow-right"
                    size="9x14" />
      </button>
    </th>
  </tr>
  </thead>
  <tbody>
    @for (row of rows; track row) {
      <tr>
        @for (dt of row; track dt) {
          <td class="td-wb-table__cell--center"
              role="gridcell"
              [id]="dt.uid"
              [attr.aria-disabled]="dt.disabled">
            <button tdWbDatePickerButton
                    type="button"
                    class="td-wb-year-picker__button"
                    [ngClass]="{'td-wb-date-picker-button--active': dt.selected, '': datePicker.isActive(dt)}"
                    [disabled]="dt.disabled"
                    (click)="datePicker.select(dt.date)">
              <span [ngClass]="{'text-info': dt.current}" [innerText]="dt.label"></span>
            </button>
          </td>
        }
      </tr>
    }
  </tbody>
</table>


